import {Component, OnDestroy, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {debounceTime, switchMap} from 'rxjs/operators';
import {EventsApiService} from 'src/app/admin/event-configuration/services/events.api.service';
import {EventSearch, EventSearchService} from 'src/app/admin/event-search.service';

@Component({
    selector: 'app-event-selection',
    templateUrl: './event-selection.component.html',
    styleUrls: ['./event-selection.component.scss'],
    standalone: false
})
export class EventSelectionComponent implements OnInit, OnDestroy, OnChanges {
  events;
  searchEventName = '';
  dropdownEvent = false;
  parnterCategory: number;
  partnerCategories: {label: string; value: number}[] = [];
  searching = false;

  @Input() event;
  @Input() pastEvents = true;
  @Input() partnerStatusRequired = false;
  @Input() displayPartnerStatus = false;
  @Input() campaignWarning = false;
  @Output() eventChange = new EventEmitter<EventSearch>();
  @Output() resetEventId = new EventEmitter();

  private searchSubject = new Subject<string>();
  private searchSubscription: Subscription;

  constructor(
    private eventService: EventSearchService,
    private eventDetailsService: EventsApiService,
  ) {}

  ngOnInit(): void {
    this.eventDetailsService.getEventPartnerCategories().subscribe(categories => (this.partnerCategories = categories));
    this.searchSubscription = this.searchSubject
      .pipe(
        debounceTime(300),
        switchMap(term => {
          this.searching = true;
          return this.eventService.filterEvents(term, this.pastEvents);
        }),
      )
      .subscribe(results => {
        this.events = results;
        this.searching = false;
      });
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    // @ts-ignore
    this.searchEventName = changes.event?.currentValue ? changes.event?.currentValue.name : '';
  }

  getEvents() {
    this.dropdownEvent = true;
    this.searching = true;
    this.searchSubject.next(this.searchEventName);
  }

  setEvent(ev) {
    this.dropdownEvent = false;
    this.searchEventName = ev.name;
    this.event = ev;
    this.eventDetailsService.getEventDetails(ev.id).subscribe(ev => {
      this.event.partner_status = ev.partner_category;
    });
    this.eventChange.emit(ev);
  }

  resetEvent() {
    this.searchEventName = '';
    this.event = '';
    this.resetEventId.emit();
  }
}
